module.exports = __webpack_public_path__ + "static/media/card.10e74535.svg";